import React from 'react'


const AdviceLink=()=>{

    return(<>
        <div className='adviceLink'>
            "Увага! Оновлено процес формування заявки для присвоєння спортивного звання. Детальну інформацію можна переглянути в розділі інструкції <a style={{textDecoration:'underline',cursor:'pointer', color:'yellow'}} href="http://title.mms.gov.ua/api/v1/assets/instructions/9283b31f-318b-4f98-bac9-badf263ea1c0.pdf" target="_blank">(ІНСТРУКЦІЯ КОРИСТУВАЧА -2- створення заявки для присвоєння спортивного звання)</a>         
        </div>
    
    </>)

}

export default AdviceLink;